/**
 * Extrae año y prefijo de etiquetas tipo SS2027, AW26, PF2028.
 */
export function parseTemporadaSortKey(label) {
  const raw = String(label || "")
    .trim()
    .toUpperCase();
  const match = raw.match(/^(.*?)(\d{2}|\d{4})\s*$/);
  if (!match) {
    return { year: 0, prefix: raw };
  }
  let year = Number(match[2]);
  if (match[2].length === 2) {
    year += year >= 70 ? 1900 : 2000;
  }
  const prefix = String(match[1] || "")
    .replace(/[^A-Z]/g, "")
    .trim();
  return { year, prefix: prefix || raw };
}

/**
 * Año más reciente primero; dentro del mismo año, alfabético (AW, FA, PF…).
 */
export function compareTemporadasByYearThenAlpha(a, b) {
  const labelA = typeof a === "string" ? a : a?.TEMPORADA || a?.Temporada || "";
  const labelB = typeof b === "string" ? b : b?.TEMPORADA || b?.Temporada || "";
  const ka = parseTemporadaSortKey(labelA);
  const kb = parseTemporadaSortKey(labelB);
  if (ka.year !== kb.year) return kb.year - ka.year;
  const byPrefix = ka.prefix.localeCompare(kb.prefix, "es");
  if (byPrefix !== 0) return byPrefix;
  return String(labelA).localeCompare(String(labelB), "es");
}

export function sortTemporadasByYearThenAlpha(list) {
  return [...(Array.isArray(list) ? list : [])].sort(
    compareTemporadasByYearThenAlpha,
  );
}
